export default "ALTER TABLE `accounts` ADD `is_excluded_from_totals` integer DEFAULT 0 NOT NULL;\n";